import script from "./acompanhar-chamado.vue?vue&type=script&setup=true&lang=js"
export * from "./acompanhar-chamado.vue?vue&type=script&setup=true&lang=js"

import "./acompanhar-chamado.vue?vue&type=style&index=0&id=12fe313d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fe313d"]])

export default __exports__